var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "q-toolbar" }, [
        _c(
          "div",
          { staticClass: "q-toolbar-buttons" },
          [
            _c(
              "q-button",
              {
                staticClass: "q-toolbar-btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.limitationDialog = true
                  },
                },
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "filter"] } })],
              1
            ),
            _vm._v(" "),
            _c(
              "q-button",
              { staticClass: "q-toolbar-btn", on: { click: _vm.refreshRows } },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fas", "sync-alt"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-input",
              {
                style: _vm.searchStyle,
                attrs: {
                  placeholder: this.$qt("listStructure.searchPlaceHolder"),
                },
                model: {
                  value: _vm.word,
                  callback: function ($$v) {
                    _vm.word = $$v
                  },
                  expression: "word",
                },
              },
              [
                _c("q-button", {
                  attrs: {
                    slot: "append",
                    type: "info",
                    icon: "q-icon-search",
                  },
                  slot: "append",
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "q-table",
        {
          attrs: {
            stripe: "",
            data: _vm.filteredData,
            width: "100%",
            "sum-text": "----",
            "empty-text": this.$qt("listStructure.emptyList"),
          },
          on: {
            "row-click": _vm.rowSelected,
            "selection-change": _vm.handleSelectionChange,
          },
        },
        [
          _c("q-table-column", { attrs: { prop: "key", label: "key" } }),
          _vm._v(" "),
          _vm._l(_vm.languages, function (lan) {
            return _c("q-table-column", {
              key: lan.cultureName,
              attrs: { label: lan.name },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        [
                          _c("q-input", {
                            attrs: { size: "mini", placeholder: "" },
                            model: {
                              value: scope.row[lan.cultureName],
                              callback: function ($$v) {
                                _vm.$set(scope.row, lan.cultureName, $$v)
                              },
                              expression: "scope.row[lan.cultureName]",
                            },
                          }),
                        ],
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _vm._v(" "),
          _c("q-table-column", {
            attrs: { align: "left", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "q-toolbar-buttons" },
                      [
                        _c(
                          "q-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.updateBundle(scope.$index, scope.row)
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "save"] },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "q-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteBundle(scope.$index, scope.row)
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "trash"] },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("q-pagination", {
        attrs: {
          "page-size": _vm.listStructure.itemInPage,
          "pager-count": 11,
          total: _vm.modelsQty,
          layout: "prev ,pager , next",
          "current-page": _vm.currentPage,
          "next-text": this.$qt("listStructure.pagination.nextText"),
          "prev-text": this.$qt("listStructure.pagination.prevText"),
          background: "",
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
          "current-change": _vm.changePage,
        },
      }),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("listStructure.limitationTitle"),
            width: "50%",
            visible: _vm.limitationDialog,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.limitationDialog = $event
            },
          },
        },
        [
          _vm.limitationStructure
            ? _c(
                "div",
                [
                  _c(
                    "q-form",
                    {
                      ref: "limitationForm",
                      attrs: {
                        model: _vm.rangeModel,
                        rules: _vm.rangeRules,
                        "labq-width": "150px",
                      },
                    },
                    [
                      _c("q-form-generator", {
                        attrs: { "form-structure": _vm.limitationStructure },
                        model: {
                          value: _vm.rangeModel,
                          callback: function ($$v) {
                            _vm.rangeModel = $$v
                          },
                          expression: "rangeModel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("div", [
                _c("span", [
                  _vm._v(_vm._s(this.$qt("listStructure.limitationNotSet"))),
                ]),
              ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                { attrs: { type: "primary" }, on: { click: _vm.limit } },
                [_vm._v(_vm._s(this.$qt("listStructure.confirmLimitation")))]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.limitationDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(this.$qt("listStructure.rejectLimitation")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("model.deleteDialog.title"),
            visible: _vm.deleteDialog,
            width: "30%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteDialog = $event
            },
          },
        },
        [
          _c("span", [
            _vm._v(_vm._s(this.$qt("model.deleteDialog.warningNote"))),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteModel()
                    },
                  },
                },
                [_vm._v(_vm._s(this.$qt("model.deleteDialog.confirm")))]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deleteDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(this.$qt("model.deleteDialog.cancel")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }